<template>
    <b-card class="m-4">
        <template v-slot:header>
            <div class="text-right">
                <b-button variant="primary" :to="{ name: 'CustomerNew' }"><font-awesome-icon icon="plus"></font-awesome-icon> Nuevo</b-button>
            </div>
        </template>
        <b-row class="mb-2">
            <b-col sm="5" md="6" class="my-1">
                <b-input-group size="sm" prepend="Mostrar" append="registros">
                    <b-form-select v-model="customers.itemsPerPage" id="perPageSelect" size="sm" :options="customers.pageOptions"
                                   style="max-width: 5em"></b-form-select>
                </b-input-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-input-group prepend="Filtrar: ">
                    <b-input v-model="customers.filter" debounce="300"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-table :items="loadData" :fields="customers.fields" :filter="customers.filter" :current-page="customers.currentPage"
                 :per-page="customers.itemsPerPage" empty-text="Sin registros" empty-filtered-text="Sin coincidencias"
                 striped bordered hover small show-empty :responsive="true"  :sort-by.sync="customers.sortBy" ref="customersTable"
                 class="text-left">
            <template v-slot:thead-top>
                <b-tr>
                    <b-th v-for="(field, index) in customers.fields" :key="field.key">
                        <b-row v-if="customers.filters[index]">
                            <b-col v-if="customers.filters[index].inputType === 'Select'">
                                <b-select v-model="customers.filters[index].value">
                                    <b-select-option value="">Todos</b-select-option>
                                    <b-select-option value="TRUE">Activo</b-select-option>
                                    <b-select-option value="FALSE">Inactivo</b-select-option>
                                </b-select>
                            </b-col>
                            <b-col v-else-if="customers.filters[index].type === 'STRING'">
                                <b-input :placeholder="field.label" v-model="customers.filters[index].value" debounce="300"></b-input>
                            </b-col>
                        </b-row>
                    </b-th>
                </b-tr>
            </template>

            <template v-slot:cell(enabled)="row">
                <b-badge variant="primary" v-if="row.item.enabled" class="p-1">Activo</b-badge>
                <b-badge variant="warning" v-else>Inactivo</b-badge>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button-group size="sm">
                    <b-button :to="{ name: 'CustomerShow', params: { id: row.item.id }}" v-b-tooltip.hover
                              title="Detalle" variant="outline-primary">
                        <font-awesome-icon icon="search"></font-awesome-icon>
                    </b-button>
                    <b-button :to="{ name: 'CustomerEdit', params: { id: row.item.id }}" v-b-tooltip.hover
                              title="Modificar" variant="outline-primary">
                        <font-awesome-icon icon="edit"></font-awesome-icon>
                    </b-button>
                    <b-button v-b-tooltip.hover :title="row.item.enabled ? 'Desactivar' : 'Activar'"
                              variant="outline-primary" @click="changeStatus(row.item)">
                        <font-awesome-icon :icon="row.item.enabled ? 'toggle-off' : 'toggle-on'"></font-awesome-icon>
                    </b-button>
                </b-button-group>
            </template>

            <template v-slot:table-caption>
                <b-row class="no-gutters">
                    <b-col sm="5" md="6">
                        Mostrando {{ start }} a {{ end }} de {{ customers.totalRows }} registro<template v-if="customers.totalRows !== 1">s</template>
                    </b-col>
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination v-model="customers.currentPage" :total-rows="customers.totalRows"
                                      :per-page="customers.itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-table>
    </b-card>
</template>

<script>
import { customerEnableUrl, customerListUrl } from '@routes';
import * as constants from '@constants';

export default {
    props: {
        settings: Object,
        membership: Object,
        application: String
    },
    data() {
        return {
            customers: {
                fields: [
                    // { key: 'id', label: 'id', sortable: true },
                    { key: 'legalName', label: 'Razón social', sortable: true },
                    { key: 'taxId', label: 'RFC', sortable: true },
                    { key: 'phone1', label: 'Teléfono 1', sortable: true },
                    { key: 'phone2', label: 'Teléfono 2', sortable: true },
                    { key: 'email', label: 'Correo', sortable: true },
                    { key: 'enabled', label: 'Estatus', sortable: true },
                    { key: 'actions', label: 'Acciones' }
                ],
                items: [],
                filters: [
                    { column: 'c.legal_name', type: 'STRING', value: '', format: '' },
                    { column: 'c.tax_id', type: 'STRING', value: '', format: '' },
                    { column: 'c.phone1', type: 'STRING', value: '', format: '' },
                    { column: 'c.phone2', type: 'STRING', value: '', format: '' },
                    { column: 'c.email', type: 'STRING', value: '', format: '' }
                ],
                filter: '',
                isLoading: false,
                pageOptions: [25, 50, 75, 100],
                totalRows: 0,
                currentPage: 1,
                itemsPerPage: 25,
                sortBy: 'c.id',
                sortDesc: false
            }
        }
    },
    created() {
        this.$emit('update-breadcrumb-items', [{
            text: 'Clientes',
            active: true
        }]);
    },
    methods: {
        loadData(ctx) {
            if (ctx.sortBy !== '') {
                let data = {
                    filters: this.customers.filters.filter(filter => filter.value.trim() !== ''),
                    ...ctx
                };

                data.currentPage = (data.currentPage - 1) * data.perPage;

                return this.axios.post(customerListUrl(), data).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.customers.totalRows = response.data.totalRows;
                        return response.data.customers;
                    } else {
                        return [];
                    }
                }).catch(error => {
                    console.error(error);

                    return [];
                });
            }
        },
        changeStatus(customer) {
            this.$swal({
                title: `¿${customer.enabled ? 'Desactivar' : 'Activar'} al cliente ${customer.legalName}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.axios.put(customerEnableUrl(), {
                        application: this.application,
                        customerId: customer.id,
                        enabled: !customer.enabled
                    }).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            customer.enabled = !customer.enabled;

                            this.$bvToast.toast(response.data.message, {
                                title: 'Clientes',
                                variant: 'success'
                            });
                        }
                    }).catch(() => {
                        this.$bvToast.toast('Ocurrió un error al guardar la configuración.', {
                            title: 'Clientes',
                            variant: 'danger'
                        });
                    });
                }
            });
        }
    },
    watch: {
        'customers.filters': {
            handler() {
                this.$refs.customersTable.refresh();
            },
            deep: true
        }
    },
    computed: {
        start: function() {
            return this.customers.totalRows === 0 ? 0 : (this.customers.currentPage - 1) * this.customers.itemsPerPage + 1;
        },
        end: function() {
            let offset = (this.customers.currentPage - 1) * this.customers.itemsPerPage;

            return (this.customers.totalRows - offset) < this.customers.itemsPerPage ? this.customers.totalRows :
                offset + this.customers.itemsPerPage;
        }
    }
}
</script>

<style scoped>

</style>